import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import { BarrasStandard } from "./BarrasStandard";
import React, { useState, useEffect } from "react";

export const BarrasStandardVentasPorSubTipo = ({ Fecha, WidgetKey }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const { Varios: { FormateoFechaPara_yyyyMMdd } } = require('neftis7_apicaller');
  const { VEN_DocsVenta_Cabecera: { function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorSubtipo } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      //let fechaDesde = new Date(Fecha); // Copia la fecha de Fecha
      //fechaDesde.setDate(Fecha.getDate() - 365);

      const resultData = await function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorSubtipo(await FormateoFechaPara_yyyyMMdd(Fecha), await FormateoFechaPara_yyyyMMdd(Fecha), "NA*DA", "NA*DA", "NA*DA", "NA*DA");
      setData(resultData.data)
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    getData();
  }, [Fecha, WidgetKey]);

  const dataFinal = {
    title: "VENTAS POR SUBTIPO",
    icon: (
      <StoreOutlinedIcon
        className="icon"
        style={{
          backgroundColor: "rgba(128, 0, 128, 0.2)",
          color: "purple",
          width: "30px",
          height: "30px",
          margin: "0px 15px 0px 0px "
        }}
      />
    ),
  };

  return (
    <div>
      {data.length > 0 && (
        <BarrasStandard
          titulo={dataFinal.title}
          icono={dataFinal.icon}
          dataSource={data}
          CampoEjeX="SubTipoVentas"

          CampoEjeY="ImporteTotal"
          Titulo="Ventas"
          Color="purple"
        />
      )}
    </div>
  );
};